import { axiosInstance } from '../axios/axiosConfig';

const controller = 'TrainersLanding';

export const getAllTrainers = async () => {
    return await axiosInstance.post(`/${controller}/getAllTrainer`);
}

export const getPriceLevel = async () => {
    return await axiosInstance.get(`/${controller}/priceLevels`);
}

export const getSecondLanguages = async () => {
    return await axiosInstance.get(`/${controller}/secondLanguages`);
}

export const getLevelProgramOption = async () => {
    return await axiosInstance.get(`/${controller}/levelProgram`);
}

export const getStudyTimeOption = async () => {
    return await axiosInstance.get(`/${controller}/studyTime`);
}

export const getTrainerDetail = async (id) => {
    return await axiosInstance.get(`/${controller}/${id}`);
}

export const getWallet = async (id) => {
    const response = await axiosInstance.get(`/${controller}/wallet/${id}`);
    return response.data;
}

export const getTrainersLanding = async (paginationParams, filterRequest) => {
  const payload = filterRequest
    ? { paginationParams, filterRequest }
    : { paginationParams };

  const response = await axiosInstance.post(`/${controller}/GetAllTrainer`, payload);
  return response.data;
};
export const getTrainerByUserIdLanding = async (id) => {
    const response = await axiosInstance.get(`/${controller}/GetTrainerByUserId/${id}`);
    return response.data;
}

const controllerUrl = 'Trainers';
export const getTrainerById = async (id) => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetTrainerById/${id}`);
    return response.data;
}
export const getTrainerByUserId = async (id) => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetTrainerByUserId/${id}`);
    return response.data;
}
export const getTrainerRegisterStatusByUserId = async (id) => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetTrainerRegisterStatusByUserId/${id}`);
    return response.data;
}
export const getAvailableTags = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableTags`);
    return response.data;
}

export const getAvailableProficiencies = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableProficiencies`);
    return response.data;
}

export const getAvailableGraduationStatus = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableGraduationStatus`);
    return response.data;
}

export const getAvailableDegrees = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableDegrees`);
    return response.data;
}

export const getTrainerSchedules = async (publicId) => {
    const response = await axiosInstance.get(`/${controllerUrl}/Schedules/${publicId}`);
    return response.data;
}

export const postTrainerBooking = async (bookingDate, trainerPublicId) => {
    const response = await axiosInstance.post(`/${controllerUrl}/Booking`, {
        trainerPublicId: trainerPublicId,
        bookingDate: bookingDate
    });
    return response.data;
}
export const getAvailableDays = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableDays`);
    return response.data;
}
export const getAvailableInstructorStyles = async () => {
    const response = await axiosInstance.get(`/${controllerUrl}/GetAvailableInstructorStyles`);
    return response.data;
}

export const getTrainers = async (body, query) => {
    const response = await axiosInstance.post(`/${controllerUrl}/GetAllTrainer`, body, { params: { ...query } });
    return response.data;
}